import React, {Component} from 'react';
import styles from './SubscriptionToggle.scss';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Popover} from 'reactstrap';
import _map from 'lodash/map';
import {
  deleteFavourite,
  saveFavourite,
  saveMarketWatch,
  deleteMarketWatch,
  saveProfileWatch,
  deleteProfileWatch,
  showModal,
  checkIfPropertyIsTrackedByUser,
  checkIfSuburbIsTrackedByUser,
} from '../../actions';
import {getSuburbMarketId} from '../../selectors/suburbProperty';
import Button from '@material-ui/core/Button';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import TrackReasonsModal from '../Modal/TrackReasonsModal/TrackReasonsModal';
import LoginModal from '../Modal/LoginModal/LoginModal';
import UntrackModal from '../Modal/UntrackModal/UntrackModal';

const modalType = {
  PROPERTY: 'property',
  SUBURB: 'suburb'
};

class SubscriptionToggle extends Component {
  constructor(props) {
    super(props);
    let favouriteChecked = false;
    let marketWatchChecked = false;
    let profileWatchChecked = false;
    this.state = {
      favouriteChecked,
      marketWatchChecked,
      profileWatchChecked,
      modalType: '',
      isTrackingReasonModalVisible: false,
      isUntrackModalVisible: false,
    };
    this.togglePopover = this.togglePopover.bind(this);
    this.handleMarketWatchChange = this.handleMarketWatchChange.bind(this);
    this.handleProfileWatchChange = this.handleProfileWatchChange.bind(this);
  }

  componentDidMount() {
    if (this.props.user.authenticated) {
      this.isPropertyTrackedByUser();
      this.isSuburbTrackedByUser();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.isUserNewlyLoggedIn(prevProps) && this.state.modalType != '') {
      this.isPropertyTrackedByUser();
      this.isSuburbTrackedByUser();

      if (this.isPropertySubscribeButtonClicked() || this.isSuburbSubscribeButtonClicked()) {
        this.toggleUntrackModal(this.state.modalType);
      } else {
        this.toggleTrackModal(this.state.modalType);
      }
    } else if (this.isUserNewlyLoggedIn(prevProps)) {
      this.isPropertyTrackedByUser();
      this.isSuburbTrackedByUser();
    }
  }

  isUserNewlyLoggedIn = (prevProps) => {
    return !prevProps.user.authenticated && this.props.user.authenticated;
  }

  isPropertyTrackedByUser = () => {
    const payload = {
      propertyId: this.props.propertyDetail.property.propertyId,
    };
    this.props.checkIfPropertyIsTrackedByUser(payload);
  }

  isSuburbTrackedByUser = () => {
    const payload = {
      marketId: this.getMarketId()
    };

    this.props.checkIfSuburbIsTrackedByUser(payload);
  }

  isPropertySubscribeButtonClicked = () => {
    return this.state.modalType === modalType.PROPERTY && this.isCurrentPropertySubscribed();
  }

  isSuburbSubscribeButtonClicked = () => {
    return this.state.modalType === modalType.SUBURB && this.isCurrentSuburbSubscribed();
  }

  toggleTrackModal = (modalType) => {
    this.setState({isTrackingReasonModalVisible: !this.state.isTrackingReasonModalVisible, modalType: modalType});
  }

  toggleUntrackModal = (modalType) => {
    this.setState({isUntrackModalVisible: !this.state.isUntrackModalVisible, modalType: modalType});
  }

  getButtonVariant = (isSubscribed) => {
    return isSubscribed ? 'contained' : 'outlined';
  }

  getButtonColor = (isSubscribed) => {
    return isSubscribed ? 'primary' : 'secondary';
  }

  getTrackPropertyButtonLabel = (isSubscribed) => {
    return isSubscribed ? 'Property Tracked' : 'Track Property';
  }

  getTrackSuburbButtonLabel = (isSubscribed) => {
    return isSubscribed ? 'Suburb Tracked' : 'Track Suburb';
  }

  handleTrackPropertyButtonClick = (event, isLoggedIn, isSubscribed) => {
    if (isLoggedIn && isSubscribed) {
      this.toggleUntrackModal(modalType.PROPERTY);

    } else if (isLoggedIn && !isSubscribed) {
      this.toggleTrackModal(modalType.PROPERTY);

    } else {
      this.setState({modalType: modalType.PROPERTY});
      event.preventDefault();
      this.props.showModal({
        open: true,
        title: 'Sign in to your account',
        component: <LoginModal />
      });
    }
  }

  trackProperty = (trackReason) => {
    this.props.saveProfileWatch({propertyId: this.props.propertyDetail.property.propertyId,
      property: this.props.propertyDetail.property,
      subscribedPropertyReason: trackReason,
      listingId: this.props.propertyDetail.property.id,
      isPropertyClaimed: this.props.isClaimed,
      isRecentlySoldWithAgentAdvice: this.props.propertyDetail.property.recentlySold && this.props.propertyDetail.property.recentlyAdvice,
    });
    this.toggleTrackModal('');
  }

  untrackProperty = () => {
    this.props.deleteProfileWatch({propertyId: this.props.propertyDetail.property.propertyId});
    this.toggleUntrackModal('');
  }

  getMarketId = () => {
    let marketId = null;
    if (this.props.propertyDetail.property.address &&
        this.props.propertyDetail.property.address.suburb &&
        this.props.propertyDetail.property.address.postCode) {
      marketId = getSuburbMarketId(this.props.propertyDetail.property.address);
    }

    return marketId;
  }

  handleTrackSuburbButtonClick = (event, isLoggedIn, isSubscribed) => {
    const marketId = this.getMarketId();

    if (isLoggedIn && isSubscribed && marketId) {
      this.toggleUntrackModal(modalType.SUBURB);

    } else if (isLoggedIn && !isSubscribed) {
      this.toggleTrackModal(modalType.SUBURB);

    } else {
      this.setState({modalType: modalType.SUBURB});
      event.preventDefault();
      this.props.showModal({
        open: true,
        title: 'Sign in to your account',
        component: <LoginModal />
      });
    }
  }

  trackThisSuburb = (trackReason) => {
    const marketId = this.getMarketId();
    if (marketId) {
      this.props.saveMarketWatch({marketId: marketId,
        property: this.props.propertyDetail.property,
        subscribedMarketReason: trackReason,
      });
    }

    this.toggleTrackModal('');
  }

  untrackThisSuburb = () => {
    const marketId = this.getMarketId();
    this.props.deleteMarketWatch({marketId});
    this.toggleUntrackModal('');
  }

  isLoggedIn() {
    return this.props.user.authenticated;
  }

  render() {
    const isLoggedIn = this.props.user.authenticated;
    let isFavourite = this.isCurrentPropertyFavourite();
    let isProfileWatchSubscribed = this.isCurrentPropertySubscribed();
    let isMarketWatchSubscribed = this.isCurrentSuburbSubscribed();

    return (
      this.props.styleType === 'desktop' ?
        <div className={styles.container}>
          <Button
            variant={this.getButtonVariant(isProfileWatchSubscribed)}
            color={this.getButtonColor(isProfileWatchSubscribed)}
            startIcon={<HomeOutlinedIcon />}
            onClick={(e) => this.handleTrackPropertyButtonClick(e, isLoggedIn, isProfileWatchSubscribed)}
            disabled={!this.props.propertyDetail.property.hasOwnProperty('clPropertyId')}>
            {this.getTrackPropertyButtonLabel(isProfileWatchSubscribed)}
          </Button>

          <Button className={`${styles.trackSuburbButton}`}
            variant={this.getButtonVariant(isMarketWatchSubscribed)}
            color={this.getButtonColor(isMarketWatchSubscribed)}
            startIcon={<LocationOnOutlinedIcon />}
            onClick={(e) => this.handleTrackSuburbButtonClick(e, isLoggedIn, isMarketWatchSubscribed)} >
            {this.getTrackSuburbButtonLabel(isMarketWatchSubscribed)}
          </Button>

          <TrackReasonsModal
            isPropertyTrackModal={this.state.modalType === 'property' ? true : false}
            showModal={this.state.isTrackingReasonModalVisible}
            handleShowModalChange={() => this.setState({isTrackingReasonModalVisible: false})}
            handleTrackSubmit={this.state.modalType === 'property' ? (trackReason) => this.trackProperty(trackReason) : (trackReason) => this.trackThisSuburb(trackReason)} />

          <UntrackModal isPropertyUntrackModal={this.state.modalType === 'property' ? true : false}
            showModal={this.state.isUntrackModalVisible}
            handleCloseModalChange={() => this.setState({isUntrackModalVisible: false})}
            handleUntrackButtonClick={this.state.modalType === 'property' ? () => this.untrackProperty() : () => this.untrackThisSuburb()}
          />
        </div>
        :
        <React.Fragment>
          <a title="Track this suburb and Track this property"
            href="."
            id="subscriptionToggleMobile"
            onClick={this.togglePopover}
            className={styles.iconMore}>
          </a>
          <Popover
            fade={false}
            trigger="legacy"
            placement="bottom"
            isOpen={this.state.popoverOpen}
            target="subscriptionToggleMobile"
            toggle={this.togglePopover}
            className={styles.subPop}>
            {({ scheduleUpdate }) => {
              scheduleUpdate();
              return (
                <div className="m-3">
                  {this.props.propertyDetail.property.hasOwnProperty('clPropertyId') ?
                    <div className="mb-3 d-flex align-items-center" onClick={this.handleProfileWatchChange}>
                      <i className={'icon ml-0 mr-2 ' + styles.iconHome} />
                      <div>{isProfileWatchSubscribed ? 'Untrack this property' : 'Track this property'}</div>
                    </div>
                    : null}
                  <div className="d-flex align-items-center" onClick={this.handleMarketWatchChange}>
                    <i className={'icon ml-0 mr-2 ' + styles.iconMarket} />
                    {isMarketWatchSubscribed ? 'Untrack this suburb' : 'Track this suburb'}
                  </div>
                </div>
              );
            }}
          </Popover>
        </React.Fragment>
    );
  }

  togglePopover(event) {
    event.preventDefault();
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  handleFavouriteChange = () => {
    if (this.isCurrentPropertyFavourite() && this.isLoggedIn()) {
      this.props.deleteFavourite({propertyId: this.props.propertyDetail.property.propertyId});
    }
    else {
      this.props.saveFavourite({propertyId: this.props.propertyDetail.property.propertyId,
        property: this.props.propertyDetail.property,
        listingId: this.props.propertyDetail.property.id});
    }
  }

  handleProfileWatchChange() {
    if (this.isCurrentPropertySubscribed() && this.isLoggedIn()) {
      this.props.deleteProfileWatch({propertyId: this.props.propertyDetail.property.propertyId});
    }
    else {
      this.props.saveProfileWatch({propertyId: this.props.propertyDetail.property.propertyId, property: this.props.propertyDetail.property});
    }
  }

  handleMarketWatchChange() {
    if (this.props.propertyDetail.property.address &&
      this.props.propertyDetail.property.address.suburb &&
      this.props.propertyDetail.property.address.postCode) {
      let property = this.props.propertyDetail.property;
      let marketId = getSuburbMarketId(property.address);
      if (this.isCurrentSuburbSubscribed() && this.isLoggedIn()) {
        this.props.deleteMarketWatch({marketId});
      }
      else {
        this.props.saveMarketWatch({marketId: marketId, property: this.props.propertyDetail.property});
      }
    }
  }

  isCurrentPropertyFavourite() {
    let user = this.props.user;
    let propertyId = this.props.propertyDetail.property.propertyId;
    let isAFav = false;
    if (user.authenticated && propertyId && this.props.userFavourites && this.props.userFavourites.favourites) {
      let favs = _map(this.props.userFavourites.favourites, 'propertyId');
      if (favs.includes(propertyId)) {
        isAFav = true;
      }
    }
    return isAFav;
  };

  isCurrentPropertySubscribed() {
    let user = this.props.user;
    let property = this.props.propertyDetail.property;

    return user.authenticated && property.id && this.props.trackedProperties.isPropertyDisplayedTrackedByUser;
  };

  isCurrentSuburbSubscribed() {
    return this.props.user.authenticated && this.props.marketWatch.isSuburbDisplayedTrackedByUser;
  };
}

SubscriptionToggle.propTypes = {
  user: PropTypes.object,
  styleType: PropTypes.string,
  propertyDetail: PropTypes.object,
  checkIfPropertyIsTrackedByUser: PropTypes.func,
  checkIfSuburbIsTrackedByUser: PropTypes.func,
  isClaimed: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  user: state.user,
  userFavourites: state.userFavourites,
  profileWatch: state.profileWatch,
  marketWatch: state.marketWatch,
  propertyDetail: state.propertyDetail,
  trackedProperties: state.profileWatchProperties,
  isClaimed: state.propertyClaimsStatus.isClaimed,
});

const mapDispatchToProps = {
  saveFavourite,
  deleteFavourite,
  saveMarketWatch,
  deleteMarketWatch,
  saveProfileWatch,
  deleteProfileWatch,
  showModal,
  checkIfPropertyIsTrackedByUser,
  checkIfSuburbIsTrackedByUser,
};
export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionToggle);
